var __calc_dae_table = {
    'credit_type': undefined,
    'loan_sum': undefined,
    'term': undefined,
    'month_payment': undefined,
    'loan_fee': undefined,
    'adm_fee': undefined,
    'loan_interest': undefined,
    'loan_total': undefined,
    'DAE': undefined,
    'data_months': [],
};
var calc_complete = 0;

$(function () {
    $('#services li').hover(function () {
        $('[data-service=' + $(this).data('id') + ']').fadeIn(400);
    }, function () {
        $('[data-service]:not(:first)').not(this).fadeOut(400);
    });

    $('body').on('change', '[data-name=condition]', function () {
        let service_id = $(this).find('option:selected').data('service-id');
        let term = $(this).find('option:selected').data('term');
        for (let i = 12; i <= term; i += 12) {
            $('#terms_' + service_id).append('<option value="' + i + '">' + i + '</option>').trigger('refresh');
        }
    });

    $('.bi3_item > #type-credit-styler').on('click', function () {
        $(this).parent().css('z-index', '150');
        return false;
    });

    $(document).on('click', function () {
        $('.bi3_item > #type-credit-styler').parent().css('z-index', '1');
    });

    $('#dae_info-table').on('click auxclick', function () {
        if (__calc_dae_table['loan_sum'] && calc_complete) {
            let link = this.getAttribute('href');
            let form = $(this).parent().find('form[name="DAE_calc_info"]');
            let input = $(this).parent().find('input[name="json"]');
            let data = JSON.stringify(__calc_dae_table);
            input.val(data);

            form.submit();
            return false;
        } else {
            return false;
        }
    });

    $('.b_info3 input, .b_info3 select').change(function () {
        calc_complete = 0;
        __calc_dae_table = {
            'credit_type': undefined,
            'loan_sum': undefined,
            'term': undefined,
            'month_payment': undefined,
            'loan_fee': undefined,
            'adm_fee': undefined,
            'loan_interest': undefined,
            'loan_total': undefined,
            'DAE': undefined,
            'data_months': [],
        }
        let error = 0;
        $(this).parents('.b_info3').find('input, select').each(function () {
            if (!$(this).is(':valid'))
                error = 1;
        });

        let condition = $(this).parents('.b_info3').find('[data-name=condition]');
        let type_credit = $(this).parents('.b_info3').find('[data-name=type-credit]').val(); // тип кредита
        let get = parseInt($(this).parents('.b_info3').find('[data-name=get]').val()); // сумма кредита
        let term = parseInt($(this).parents('.b_info3').find('[data-name=term]').val()); // длительность

        let rate = parseFloat(condition.find('option:selected').data('rate')); // ставка по кредиту
        let loan_fee = parseFloat(condition.find('option:selected').data('loan-fee')); // комиссия за выдачу
        let adm_fee = parseFloat(condition.find('option:selected').data('adm-fee')); // административный сбор

        // let loan = parseFloat(get) * loan_fee;
        let month_rate = rate / 12;
        let get_loan_fee = Math.round(get * loan_fee);
        month_rate = parseFloat(month_rate.toFixed(5));

        __calc_dae_table['loan_sum'] = get;
        __calc_dae_table['term'] = term;
        __calc_dae_table['credit_type'] = type_credit;
        __calc_dae_table['loan_fee'] = get_loan_fee;
        if (!error) {
            let output = $('.bi4_price > strong');
            let price;
            if (type_credit === 'anui') {
                let i = Math.round((Math.pow((1 + 0.06), 1 / 12) - 1) * 100000000) / 100000000;
                let coef_anui = (i * Math.pow((1 + i), term)) / (Math.pow((1 + i), term) - 1);
                i = undefined;

                let adm_fee_current = Math.round((get * adm_fee) * 100) / 100;
                let month_payment_base = Math.round((coef_anui * get) * 100) / 100;
                let month_payment_base_fee = Math.round((month_payment_base + adm_fee_current) * 100) / 100;
                __calc_dae_table['month_payment'] = month_payment_base_fee;
                let current = get, month_credit_all = 0, month_credit_all_month = 0, month_credit_total = 0,
                    adm_fee_all = 0;

                i = 0;
                let date = new Date(), date2 = new Date();
                while (i !== term) {
                    let temp_dict = {
                        'current_date': undefined,
                        'current': undefined,
                        'loan': undefined,
                        'loan_fee': undefined,
                        'adm_fee': undefined,
                        'payment': undefined,
                    };
                    temp_dict['current_date'] = (date.getTime() / 1000).toFixed(0);
                    temp_dict['payment'] = month_payment_base_fee;
                    temp_dict['adm_fee'] = adm_fee_current;

                    date2.setMonth(date.getMonth() + 1);
                    let days = Math.round(((date2.getTime() - date.getTime()) / (1000 * 3600 * 24)));
                    let days_year = isLeapYear(date.getFullYear()) ? 366 : 365;
                    let month_credit = Math.round(((current * 6 * days) / (100 * days_year)) * 100) / 100;

                    // let month_credit = Math.round((current * coef_anui) * 100) / 100;
                    temp_dict['loan_fee'] = month_credit;
                    month_credit_all += month_credit;
                    let month_credit_base = Math.round((month_payment_base - month_credit) * 100) / 100;
                    temp_dict['loan'] = month_credit_base;

                    month_credit_total += month_payment_base_fee;
                    adm_fee_all += adm_fee_current;

                    current = Math.round((current - (month_payment_base - month_credit)) * 100) / 100;
                    if (i + 1 === term) {
                        current -= current;
                    }
                    temp_dict['current'] = current;

                    __calc_dae_table['data_months'].push(temp_dict);
                    date.setMonth(date.getMonth() + 1);
                    i++;
                }
                __calc_dae_table['loan_total'] = month_credit_total + __calc_dae_table['loan_fee'];
                __calc_dae_table['loan_interest'] = month_credit_all;
                __calc_dae_table['adm_fee'] = adm_fee_all;
                delete (i);

                price = month_payment_base_fee;
            } else if (type_credit === 'diff') {
                let month_payment_base = Math.round((get / term) * 100) / 100, current = get, month_credit,
                    month_credit_all = 0, month_credit_all_month, month_credit_total = 0, adm_fee_all = 0;

                let adm_fee_current = Math.round((get * adm_fee) * 100) / 100;

                let biggest_credit, smallest_credit;
                let i = 0, date = new Date();
                // console.log(`Базовая ставка: ${month_payment_base}`);
                while (i !== term) {
                    let temp_dict = {
                        'current_date': undefined,
                        'current': undefined,
                        'loan': undefined,
                        'loan_fee': undefined,
                        'adm_fee': undefined,
                        'payment': undefined,
                    };
                    temp_dict['current_date'] = (date.getTime() / 1000).toFixed(0);
                    temp_dict['loan'] = month_payment_base;
                    let days = days_month(date.getFullYear(), date.getMonth() + 1);
                    let days_year = isLeapYear(date.getFullYear()) ? 366 : 365;
                    let persantage_month = rate * (days / days_year);
                    persantage_month = rate/12;
                    month_credit = Math.round((current * persantage_month) * 100) / 100;
                    temp_dict['loan_fee'] = month_credit;
                    // console.log(`Выплата кредитной части: ${month_credit}`);
                    month_credit_all_month = Math.round((month_payment_base + month_credit) * 100) / 100;
                    adm_fee_all += adm_fee_current;
                    month_credit_all_month = Math.round((month_credit_all_month + adm_fee_current) * 100) / 100;
                    month_credit_total += month_credit_all_month;
                    temp_dict['payment'] = month_credit_all_month;
                    temp_dict['adm_fee'] = adm_fee_current;
                    month_credit_all += month_credit;
                    current = Math.round((current - month_payment_base) * 100) / 100;
                    temp_dict['current'] = current;
                    // console.log(`Оставшаяся сумма: ${current}`);
                    if (i === 0) {
                        biggest_credit = month_credit_all_month;
                    }
                    __calc_dae_table['data_months'].push(temp_dict);
                    date.setMonth(date.getMonth() + 1);
                    i++;
                    if (i === term) {
                        temp_dict['current'] = current = 0;
                    }
                }

                smallest_credit = month_credit_all_month;
                price = '${biggest_credit}~${smallest_credit}';
                __calc_dae_table['month_payment'] = price;
                __calc_dae_table['loan_total'] = month_credit_total;
                __calc_dae_table['loan_interest'] = month_credit_all;
                __calc_dae_table['adm_fee'] = adm_fee_all;
                delete (i);
            }
            if (price.length < 12) {
                output.css('font-size', '48px');
            }
            if (price.length >= 12) {
                output.css('font-size', '40px');
            }
            if (price.length >= 15) {
                output.css('font-size', '33px');
            }
            if (price.length >= 18) {
                output.css('font-size', '30px');
            }
            if (price.length >= 19) {
                output.css('font-size', '25px');
            }

            output.html(price);
            calc_complete = 1;
            __calc_dae_table['DAE'] = Math.round(IRR_start() * 10000) / 100 + '%';
        } else {
            calc_complete = 0;
            return false;
        }
    });

    $('#send').click(function () {
        $('form:visible').submit();
    })
});

function IRR_start() {
    let IRRval = [];
    let term = __calc_dae_table['term'];
    IRRval.push(-(__calc_dae_table['loan_sum']));
    for (i = 0; i < term; i++) {
        let rental;
        if (i === 0) {
            rental = Math.round((__calc_dae_table['loan_fee'] + __calc_dae_table['data_months'][i]['payment']) * 1000) / 1000;
        } else {
            rental = __calc_dae_table['data_months'][i]['payment'];
        }
        IRRval.push(rental);
    }

    let IRR = IRRCalc(IRRval, 0.001);
    IRR = Math.round(IRR * 1000000) / 1000000;
    let dae = Math.pow(1 + IRR, 12) - 1;
    dae = Math.round(dae * 10000) / 10000;
    return dae;
}


function IRRCalc(values, guess) {
    var irrResult = function(values, dates, rate) {
        var r = rate + 1;
        var result = values[0];
        for (var i = 1; i < values.length; i++) {
            result += values[i] / Math.pow(r, (dates[i] - dates[0]) / 365);
        }
        return result;
    };

    // Calculates the first derivation
    var irrResultDeriv = function(values, dates, rate) {
        var r = rate + 1;
        var result = 0;
        for (var i = 1; i < values.length; i++) {
            var frac = (dates[i] - dates[0]) / 365;
            result -= frac * values[i] / Math.pow(r, frac + 1);
        }
        return result;
    };

    // Initialize dates and check that values contains at least one positive value and one negative value
    var dates = [];
    var positive = false;
    var negative = false;
    for (var i = 0; i < values.length; i++) {
        dates[i] = (i === 0) ? 0 : dates[i - 1] + 365;
        if (values[i] > 0) positive = true;
        if (values[i] < 0) negative = true;
    }

    // Return error if values does not contain at least one positive value and one negative value
    if (!positive || !negative) return '#NUM!';

    // Initialize guess and resultRate
    var guess = (typeof guess === 'undefined') ? 0.1 : guess;
    var resultRate = guess;

    // Set maximum epsilon for end of iteration
    var epsMax = 1e-10;

    // Set maximum number of iterations
    var iterMax = 50;

    // Implement Newton's method
    var newRate, epsRate, resultValue;
    var iteration = 0;
    var contLoop = true;
    do {
        resultValue = irrResult(values, dates, resultRate);
        newRate = resultRate - resultValue / irrResultDeriv(values, dates, resultRate);
        epsRate = Math.abs(newRate - resultRate);
        resultRate = newRate;
        contLoop = (epsRate > epsMax) && (Math.abs(resultValue) > epsMax);
    } while(contLoop && (++iteration < iterMax));

    if(contLoop) return '#NUM!';

    // Return internal rate of return
    return resultRate;
}


function isLeapYear(year) {
    return year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0);
}

function days_month(year, month) {
    return new Date(year, month, 0).getDate();
}

//# sourceMappingURL=main.js.map